import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { ControlContainer, ReactiveFormsModule } from '@angular/forms';
import { TiptapEditorDualLangComponent } from '../tiptap-editor-dual-lang/tiptap-editor-dual-lang.component';

@Component({
  selector: 'lib-rich-editor-dual-lang-text-area',
  imports: [ReactiveFormsModule, TiptapEditorDualLangComponent],
  templateUrl: './rich-editor-dual-lang-text-area.component.html',
  styleUrl: './rich-editor-dual-lang-text-area.component.scss',
  viewProviders: [
    {
      provide: ControlContainer,
      useFactory: () => inject(ControlContainer, { skipSelf: true }),
    },
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class RichEditorDualLangTextAreaComponent {
  inputFormControlName = input.required<string>();
  id = input.required<string>();
  name = input.required<string>();

  label = input<string>();
  placeholderEn = input<string>('');
  placeholderAr = input<string>('');
  inputClass = input<string>('');
  width = input<string>('42.3125');
  height = input<string>('6.5');
  isHasToolTip = input<boolean>(false);
  canResize = input<boolean>(true);

  startIcon = input<string>();
  endIcon = input<string>();

  minlength = input<number>();
  maxlength = input<number>(6000);

  disabled = input<boolean>(false);
  readonly = input<boolean>();
  value = input<string | number>();
  requiredEn = input<boolean>(false);
  requiredAr = input<boolean>(false);
  requiredGroup = input<boolean>(false);
  isSingleInput = input<boolean>(false);
  equation = input<string | undefined>(undefined);

  endIconCLick = output<void>();
  typing = output<string>();
}
